import styled from "styled-components";
export const RolesSc = styled.div`
  width: 100vw;
  position: absolute;
  top: 55px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 90vh;
  padding-top: 10px;
  .roles-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 40%;
    padding: 20px;
    background-color: #fff;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
  }
  label {
    font-size: 1rem;
    font-weight: bold;
    margin-bottom: 5px;
    color: black;
  }
  input {
    border: 2px solid #ddd;
    padding: 10px;
    width: 100%;
    border-radius: 5px;
    margin-bottom: 10px;
    font-size: 1rem;
    color: #666;
  }
  button {
    padding: 10px 20px;
    background-color: #1e59d9;
    color: #fff;
    font-size: 1rem;
    font-weight: bold;
    border-radius: 5px;
    border: none;
    cursor: pointer;
  }
  button:hover {
    background-color: #0d47a1;
  }
`;
